// Docs: https://aws.amazon.com/developer/application-security-performance/articles/image-optimization
export function cloudfrontLoader({ src, width, quality }) {
  const imageUrl = src.replace(
    /https:\/\/prompz-bucket\.s3\.amazonaws\.com\/|https:\/\/prompz-bucket\.s3\.us-east-1\.amazonaws\.com\//,
    ''
  );
  const url = new URL(`https://d2dtzxv2m7w0r5.cloudfront.net/${imageUrl}`);
  url.searchParams.set('format', 'auto');
  url.searchParams.set('width', width.toString());
  url.searchParams.set('quality', (quality || 75).toString());
  return url.href;
}
